











import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'NotFoundError404',
  components: {},
})
export default class NotFoundError404 extends Vue {
  loaded = false;
  async mounted() {
    this.loaded = false;
    const lang = localStorage.getItem('lang') || 'fr';
    await this.translationService.getTranslations(lang);
    this.loaded = true;
  }
}
